import React from 'react';
import Content from '../../../components/Pages/FinancialInstitution/Statements';
import FinancialInstitutionLayout from '../../../components/Layout/FinancialInstitution';

function Statements() {
  document.title = 'Financial Institution: Statements';

  return (
    <FinancialInstitutionLayout childrenCentered>
      <Content />
    </FinancialInstitutionLayout>
  );
}

export default Statements;
